export default __webpack_public_path__ + "844551da47d5ef4f0433278eb4b7776a.png";